export default __webpack_public_path__ + "static/media/9 Dark.bae5f796.png";